// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"296":"ac0501f2","710":"18d6bcd0"}[chunkId] + ".chunk.js";
};